import React, { useEffect, useState } from "react";
import { Button, Modal, Table } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import Footer from "../../../components/Footer";
import NavBar from "../../../components/NavBar";
import SideBar from "../../../components/SideBar";
import { API_URL, TOKEN } from "../../../variables/constants";
import AddProfession from "./AddProfession";
import { toast } from "react-toastify";
import ActionDropdown from "../../production/components/ActionDropdown";

const Professions = () => {
  const [professions, setProfessions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedProfession, setSelectedProfession] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const fetchProfessions = () => {
    axios
      .get(`${API_URL}/api/parametre/type/PROFESSION`, {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        const sorted = [...res.data].sort((a, b) =>
          (a.libelleParametre || "").localeCompare(
            b.libelleParametre || "",
            "fr",
            { sensitivity: "base" }
          )
        );
        setProfessions(sorted);
      })
      .catch((err) => console.error("Error fetching professions:", err));
  };

  useEffect(() => {
    fetchProfessions();
  }, [showModal]);

  const handleShowModal = (edit = false, profession = null) => {
    setShowModal(true);
    setEditMode(edit);
    setSelectedProfession(profession);
  };

  const handleDeleteProfession = (parametreId) => {
    Modal.confirm({
      title: "Êtes-vous sûr de vouloir supprimer cette profession ?",
      content: "Cette action est irréversible",
      okText: "Oui",
      okType: "danger",
      cancelText: "Annuler",
      onOk: () => {
        axios
          .delete(`${API_URL}/api/parametre/${parametreId}`, {
            headers: { Authorization: `Bearer ${TOKEN}` },
          })
          .then(() => {
            setProfessions((prev) =>
              prev.filter((profession) => profession.parametreId !== parametreId)
            );
            toast.success("Profession supprimée avec succès.");
          })
          .catch((err) => {
            console.error("Error deleting profession:", err);
            toast.error("Erreur lors de la suppression de la profession.");
          });
      },
    });
  };

  const columns = [
    {
      title: "Nom",
      dataIndex: "libelleParametre",
      key: "libelleParametre",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, profession) => (

        <ActionDropdown
          actions={[
            {
              key: "edit",
              label: "Modifier",
              icon: <i className="bx bx-edit-alt" />,
              onClick: () => handleShowModal(true, profession),
            },
            {
              key: "delete",
              label: "Supprimer",
              icon: <i className="bx bx-trash" />,
              danger: true,
              onClick: () => handleDeleteProfession(profession.parametreId),
            },
          ]}
        />
      ),
    },
  ];

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SideBar currentMenu="AUTRES_PARAMETRES" />
        <div className="layout-page">
          <NavBar />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                style={{ marginBottom: 16 }}
                onClick={() => handleShowModal()}
              >
                Ajouter une nouvelle profession
              </Button>
              <div className="card">
                <h5 className="card-header">Paramétrage des professions</h5>
                <Table
                  rowKey="parametreId"
                  columns={columns}
                  dataSource={professions.slice(
                    (currentPage - 1) * pageSize,
                    currentPage * pageSize
                  )}
                  pagination={{
                    current: currentPage,
                    pageSize,
                    total: professions.length,
                    onChange: setCurrentPage,
                    showSizeChanger: true,
                  }}
                />
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

      <AddProfession
        show={showModal}
        handleClose={() => setShowModal(false)}
        editMode={editMode}
        selectedProfession={selectedProfession}
        professions={professions}
        onAdd={(newProfession) => {
          setProfessions((prev) =>
            [...prev, newProfession].sort((a, b) =>
              (a.libelleParametre || "").localeCompare(
                b.libelleParametre || "",
                "fr",
                { sensitivity: "base" }
              )
            )
          );
        }}
      />
    </div>
  );
};

export default Professions;
